import React from 'react'

const ListDropConditionalWrapper = title => (children, display = true) => (
    display ? (
    <li className="periode-item-container">
         {title && <div className="text-periode-date accordion-headline title-large-light">{title}</div>}
        {children}
    </li>
    ) : ''
)

export default ListDropConditionalWrapper